<template>
  <div class="relative-article">
    <div class="box box-align-center ra-top">
      <div class="rat-txt">相关{{ title }}推荐：</div>
      <el-button type="primary" plain icon="el-icon-plus" @click="() => (chooseVisible = true)"> 选{{ title }}
      </el-button>
    </div>
    <div class="ra-table">
      <dy-table :columns="columns" :table-data="tableData" :isShowPager="false"></dy-table>
    </div>
    <el-dialog v-if="chooseVisible" :title="`选${title}`" :visible.sync="chooseVisible" append-to-body width="60%"
      :close-on-click-modal="false">
      <recommendCommon :type="type" :columns="_columns" @close-dialog="() => (chooseVisible = false)"
        @saveData="saveData" :list="this.tableData" :title="title"></recommendCommon>
    </el-dialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import recommendCommon from './recommendCommon';
export default {
  components: {
    DyTable,
    recommendCommon,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '课程',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    list(newVal, oldVal) {
      this.tableData = newVal;
    },
    // tableData(newArr, oldArr) {
    //     this.$emit('save-data', this.tableData);
    // }
  },
  data() {
    return {
      tableLoading: true,
      columns: [],
      _columns: [],
      tableData: [],

      chooseVisible: false,
    };
  },
  created() {
    let s_col = [

      {
        key: 'publishStatus',
        title: '发布状态',
        render: ({ row }) => {
          if (row.publishStatus == 0) {
            return (
              <div>
                <el-button type='success' round size='mini'>
                  待发布
                </el-button>
              </div>
            );
          } else if (row.publishStatus == 1) {
            return (
              <div>
                <el-button type='primary' round size='mini'>
                  已发布
                </el-button>
              </div>
            );
          } else if (row.publishStatus == 2) {
            return (
              <div>
                <el-button type='warning' round size='mini'>
                  已下线
                </el-button>
              </div>
            );
          }
        },
      },
    ];
    let col = [
      {
        key: 'recommendId',
        title: `${this.title}Id`,
      },
      {
        key: 'recommendName',
        title: `${this.title}名称`,
      },
      {
        key: 'recommendCategory',
        title: `${this.title}分类`,
      },
      {
        key: 'recommendUser',
        title: '操作人',
      },
      {
        key: 'recommendTime',
        title: `最后更新时间`,
      },
    ]
    if (this.type == 1) {
      col.splice(3, 0, {
        key: 'type',
        title: '课程类型',
        render: ({ row }) => {
          return (
            <div>
              {row.type == 1 && '音视频课程'}
              {row.type == 2 && '项目式课程'}
            </div>
          );
        },
      });

    } else if (this.type == 2) {
    } else if (this.type == 3) {
      s_col = [];
    }
    this.columns = [
      ...col,
      ...s_col,
      {
        key: '',
        title: '操作',
        render: ({ row }) => {
          return (
            <div onClick={() => this.delItem(row)}>
              <el-link type='danger'>删除</el-link>
            </div>
          );
        },
      },
    ];
    this._columns = [...col, ...s_col];
  },
  mounted() {
    this.tableData = this.list;
  },
  methods: {
    //删除数据
    delItem(row) {
      let index = this.tableData.findIndex((item) => item.id == row.id);
      this.tableData.splice(index, 1);
      this.saveData();
    },

    saveData(arr) {
      this.tableData = arr || this.tableData;
      this.$emit('saveData', {
        type: this.type,
        data: this.tableData,
      });
    },
  },
};
</script>
<style scoped>
.ra-table {
  margin-top: 12px;
  margin-bottom: 22px;
}
</style>
